import { render } from "./CompetitionForm.vue?vue&type=template&id=6aa3eeca&scoped=true"
import script from "./CompetitionForm.vue?vue&type=script&lang=js"
export * from "./CompetitionForm.vue?vue&type=script&lang=js"

import "./CompetitionForm.vue?vue&type=style&index=0&id=6aa3eeca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa3eeca"]])

export default __exports__